<template>
<div class="chapter">
<div class="inner_page">
      ﻿

	
	
		
		
			
			<link href="styles/default.css" rel="stylesheet" type="text/css"/>
<title>The Angel
Answer Book</title>
<p class="ser" id="AgI"><a href="#/contents#bbp_1" id="aap_1"><img alt="images/img-19-1.jpg" id="z19-1" src="images/img-19-1.jpg"/></a><span id="pz19-1"></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?437cd906